import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { LeadgetPageSize } from 'src/app/shared/utils/calsoft-validators';
import { ListColumn } from 'src/app/shared/list/list-column.model';

import { CompaniesService } from 'src/app/services/companies.service';
import { Router, NavigationEnd } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'calsoft-account-companies-table',
  templateUrl: './account-companies-table.component.html',
  styleUrls: ['./account-companies-table.component.scss']
})
export class AccountCompaniesTableComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';

  @Input() leadId: any;
  @Input() defaultSetType: any;
  @Input() defaultSet: any;

  @Input() type: any;

  dialerShow: boolean;
  redirected: boolean;
  textAccount: string;
  LeadDetailsObject: any = {};

  constructor(
    private companiesService: CompaniesService,
    private router: Router,
    private location: Location,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  @Input() columns: ListColumn[] = []

  filterSelectObj = [];
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;


  ngOnInit(): void {

    this.columns = [
      /*  { name: 'select', property: 'select', visible: true, isModelProperty: true, isSticky: true },*/
      { name: 'Name', property: 'name', visible: true, isModelProperty: true, isSticky: true, cssClasses: ['text-secondary', 'font-medium'] },
      //      { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: true },
      //     { name: 'No of employees', property: 'noOfemployees', visible: true, isModelProperty: false },
      { name: 'Open Deal Amount', property: 'openDealAmount', visible: true, isModelProperty: false },
      { name: 'Won Deals Amount', property: 'wonDealAmount', visible: true, isModelProperty: false },
      { name: 'Last Contacted Time', property: 'updatedDate', visible: true, isModelProperty: true },
      //     { name: 'Industry Type', property: 'industryType', visible: true, isModelProperty: true },
      { name: 'Sales Owner', property: 'ownerEmail', visible: true, isModelProperty: true },
      //      { name: 'Business Type', property: 'businessType', visible: true, isModelProperty: true },
      { name: 'Action', property: 'actions', visible: true, disabled: true },
    ] as ListColumn[];

    this.filterSelectObj = [

      // {
      //   name: 'Select',
      //   property: 'disable',
      //   type: 'disable',
      //   position: 'firstValue',
      //   options: [],

      // },
      {
        name: 'Name',
        property: 'name',
        type: 'text',
        position: 'firstValue',
        options: []
      },
      {
        name: 'Open deal amount',
        property: 'openDealAmount',
        type: 'text',
        position: 'secondValue',
        options: []
      },

      {
        name: 'Won Deals Amount',
        property: 'wonDealAmount',
        type: 'text',
        position: 'thirdValue',
        options: []
      },
      // {
      //   name: 'Phone No',
      //   property: 'phoneNumber',
      //   type: 'text',
      //   position: 'thirdValue',
      //   options: []
      // },
      // {
      //   name: 'No of employees',
      //   property: 'noOfemployees',
      //   type: 'text',
      //   position: 'fourthValue',
      //   options: []
      // },
      {
        name: 'Last Contacted Time',
        property: 'updatedDate',
        type: 'select',
        position: 'fourthValue',
        options: [],
        display: true
      },
      {
        name: 'Industry Type',
        property: 'industryType',
        type: 'select',
        position: 'seventhValue',
        options: []
      },
      {
        name: 'Sales Owner',
        property: 'ownerEmail',
        type: 'multiSelect',
        position: 'eighthValue',
        options: [],
        display: true
      },

      // {
      //   name: 'Busniess Type',
      //   property: 'businessType',
      //   type: 'select',
      //   position: 'ninthValue',
      //   options: [],
      //   display: true
      // },
    ]



    if (this.leadId > 0) {
      this.getAllCompany();
    } else {

      this.companyList = [];
    }


  }
  isPopupOpenTwo = false;
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];

  totalElements: number = 0;
  sortParam: any = 'updatedDate' + "," + Constant.Dsc;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  companyList: any = [];
  private dateFormat = Constant.dateFormat;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  spinner: boolean;
  totalLeadCount: any;
  elements: any
  pageList: any;

  pageSizeValue: any;
  sortParamInit: any = 'updatedDate' + "," + Constant.Dsc;
  getAllCompany() {

    this.companiesService.getAllCompaniessByEntityIdNew(this.page, this.size, this.sortParam != undefined ? this.sortParam : this.sortParamInit, this.leadId).subscribe(
      res => {
        this.spinner = false;

        this.totalElements = res['totalElements'];
        this.totalLeadCount = res['totalElements'];
        this.companyList = new MatTableDataSource();
        this.elements = res['numberOfElements'];
        this.companyList = res['content'];

        //  console.log("the product list is"+JSON.stringify(this.productList));

        this.companyList.sort = this.sort;
        this.pageList = res['totalElements'];
        this.companyList.paginator = this.paginator;
        this.pageSizeValue = LeadgetPageSize(this.pageList);

      },
      error => {
        this.spinner = false;
      }
    )

  }

  getUpdate(event) {

    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;


    let localtion = this.router.url;
    const questionMarkIndex = localtion.indexOf('?');



    if (questionMarkIndex !== -1) {
      // Extract the substring before the ?
      const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

      // Replace the original string with the substring before the ?
      localtion = beforeQuestionMark;
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];

    localtion = localtion.split('&page')[0]


    if (this.sortParam == undefined) {

      this.sortParam = 'updatedDate' + "," + Constant.Dsc;

    }

   // this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

    this.redirected = false;

    this.getAllCompany();
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }


  sortData(event) {
    if (event.active != 'categoryNames' && event.active != 'icons' && event.active != 'select' && event.active != 'actions') {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.sortParam = event.active;
      if (event.direction == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.getAllCompany();
    }
  }

  editProduct(leadId, setId) {

    this.dialog.closeAll()

    if (this.defaultSetType == 0) {
      this.router.navigate([`companies/add-edit-companies/${leadId}/${setId}`])
    } else {
      this.router.navigate([`companies/add-edit-companies/${leadId}/${setId}`])
    }

  }


  deleteAllProductId(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.companiesService.deleteByLeadId(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllCompany();

        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  getRelativeTime(dateString: string): string {
    const activityDate = new Date(dateString);
    const now = new Date(); // Using component initialization time for consistency
    const diffInSeconds = Math.floor((now.getTime() - activityDate.getTime()) / 1000);

    const intervals: { [key: string]: number } = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60
    };

    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }
    return 'Just now';
  }

  goToCompanyById(companyId: any) {
    if (companyId == null || companyId == 0) {
      this.snackBar.open('No Company Associated', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      return;
    }

    this.router.navigate(['companiesDetail', companyId]);
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}





